import MuiTextField from '@material-ui/core/TextField';
import Palette from '@opsbase/lib-palette';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
export const TextField = React.forwardRef((props, ref) => {
    const { value = '', type = 'text', autoComplete, placeholder, rows, label, disabled, className, multiline = false, helperText, validator, InputProps = {}, inputProps = {}, InputLabelProps = {}, inputRef, noBorder = false, noMargin = false, white = false, autoFocus = false, fullWidth = false, onClick, onKeyDown, onKeyUp, onKeyPress, onPaste, onChange, onBlur, onFocus, onTextInput, error: propsError, } = props;
    const [error, setError] = useState(propsError);
    useEffect(() => setError(propsError), [propsError]);
    const handleChange = useCallback(e => {
        const v = e.currentTarget.value;
        if (type === 'number' && !!v)
            onChange(parseFloat(v));
        else
            onChange === null || onChange === void 0 ? void 0 : onChange(v);
        if (validator) {
            validator
                .validate(v)
                .then(() => setError(''))
                .catch(e2 => setError(e2.message));
        }
    }, [type, onChange, validator]);
    const handleBlur = useCallback(e => {
        const v = e.currentTarget.value;
        if (validator) {
            validator
                .validate(v)
                .then(() => {
                onBlur === null || onBlur === void 0 ? void 0 : onBlur(v);
                setError('');
            })
                .catch(e2 => setError(e2.message));
        }
        else {
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(v);
        }
    }, [onBlur, validator]);
    const inputPropsStyle = InputProps === null || InputProps === void 0 ? void 0 : InputProps.style;
    InputProps.style = useMemo(() => ({
        ...inputPropsStyle,
        backgroundColor: white ? Palette.White.main : undefined,
    }), [inputPropsStyle, white]);
    return (React.createElement(MuiTextField, { autoComplete: autoComplete, ref: ref, type: type, multiline: multiline, rows: rows, className: className, autoFocus: autoFocus, fullWidth: fullWidth, margin: noMargin ? 'none' : 'dense', label: label, disabled: disabled, error: !!error, helperText: error || helperText, variant: noBorder ? undefined : 'outlined', value: value, InputProps: InputProps, inputProps: inputProps, InputLabelProps: InputLabelProps, inputRef: inputRef, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, onPaste: onPaste, onChange: handleChange, onFocus: onFocus, onBlur: handleBlur, onInput: onTextInput, placeholder: placeholder }));
});
export default TextField;
